import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_MEDIA_CAROUSEL_NAV } from '@estee/elc-service-view-names';
import { IProductImageNavMenu } from './ProductImageNavMenu';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductImageNavMenu>(
    () => import('./ProductImageNavMenu'),
    PRODUCT_MEDIA_CAROUSEL_NAV
);
